export const GET_TRANSPORTATION_MODES_START = "GET_TRANSPORTATION_MODES_START";
export const GET_TRANSPORTATION_MODES_SUCCESS = "GET_TRANSPORTATION_MODES_SUCCESS";
export const GET_TRANSPORTATION_MODES_FAILURE = "GET_TRANSPORTATION_MODES_FAILURE";
